<template>
  <div ref="intersectionContainer">
    <h1>Отклоненные сообщения</h1>
    <ModerateAlertsTable  status="1"/>
  </div>
</template>

<script>
import ModerateAlertsTable from "./components/ModerateAlertsTable.vue";

export default {
  components: {
    ModerateAlertsTable
  }
};
</script>